import React, { useEffect, createElement } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { useLocation } from 'react-router-dom';
interface LayoutProps {
  children: React.ReactNode;
}
const pageTitles: Record<string, string> = {
  '/': 'Helgi Gudmundsson',
  '/about': 'Helgi Gudmundsson - About',
  '/writing': 'Helgi Gudmundsson - Writing',
  '/writing/on-feedback': 'Helgi Gudmundsson - On Feedback',
  '/writing/on-conflict': 'Helgi Gudmundsson - On Conflict',
  '/writing/lessons-of-leadership': 'Helgi Gudmundsson - Lessons of Leadership',
  '/writing/lessons-of-agility': 'Helgi Gudmundsson - The Lessons of Agility',
  '/writing/lessons-of-strategy': 'Helgi Gudmundsson - The Lessons of Strategy',
  '/writing/on-teams': 'Helgi Gudmundsson - On Teams',
  '/services': 'Helgi Gudmundsson - Services',
  '/services/coaching': 'Helgi Gudmundsson - Coaching',
  '/services/embedded-partner': 'Helgi Gudmundsson - Embedded Partner',
  '/services/new-to-leadership': 'Helgi Gudmundsson - New to Leadership',
  '/services/conflict-and-conversations': 'Helgi Gudmundsson - Conflict and Conversations',
  '/services/meetings-and-facilitation': 'Helgi Gudmundsson - Meetings and Facilitation',
  '/services/leading-in-complexity': 'Helgi Gudmundsson - Leading in Complexity',
  '/services/courses': 'Helgi Gudmundsson - Courses',
  '/services/courses/conflict-coaching': 'Helgi Gudmundsson - Conflict Coaching',
  '/services/courses/first-time-manager': 'Helgi Gudmundsson - First-Time Manager',
  '/services/courses/better-online-meetings': 'Helgi Gudmundsson - Better Online Meetings',
  '/services/courses/better-online-workshops': 'Helgi Gudmundsson - Better Online Workshops',
  '/services/courses/modern-product-management': 'Helgi Gudmundsson - Modern Product Management',
  '/services/courses/art-of-facilitation': 'Helgi Gudmundsson - The Art of Facilitation',
  '/services/workshops': 'Helgi Gudmundsson - Workshops',
  '/services/workshops/strategy': 'Helgi Gudmundsson - Strategy Workshop',
  '/services/workshops/feedback-culture': 'Helgi Gudmundsson - Feedback Culture Workshop',
  '/services/workshops/coaching-skills': 'Helgi Gudmundsson - Coaching Skills for Managers',
  '/services/talks': 'Helgi Gudmundsson - Talks',
  '/events': 'Helgi Gudmundsson - Events',
  '/contact': 'Helgi Gudmundsson - Contact',
  '/privacy': 'Helgi Gudmundsson - Privacy',
  '/terms': 'Helgi Gudmundsson - Terms'
};
const pageDescriptions: Record<string, string> = {
  '/': 'Leadership coach, facilitator and trainer based in Reykjavík.',
  '/about': 'About Helgi Gudmundsson - leadership coach, facilitator and trainer.',
  '/writing': 'Writing on leadership, teams, conflict, strategy and agility.',
  '/services': 'Leadership coaching, facilitation, training and embedded partnership.',
  '/contact': 'Get in touch with Helgi Gudmundsson.'
};
function setMetaTag(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function Layout({
  children
}: LayoutProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  useEffect(() => {
    const title = pageTitles[pathname] ?? 'Helgi Gudmundsson';
    document.title = title;
    // Open Graph meta tags for social sharing
    setMetaTag('og:title', title);
    setMetaTag('og:url', window.location.href);
    const description = pageDescriptions[pathname] ?? 'Leadership coach, facilitator and trainer based in Reykjavík.';
    setMetaTag('og:description', description);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-white overflow-x-hidden" data-id="element-117">
      <Navbar data-id="element-118" />
      <main className="flex-grow" data-id="element-119">{children}</main>
      <Footer data-id="element-120" />
    </div>;
}